import { serviceRequest } from 'utils/http';
import { Service } from 'common/api';

export function getReferralHistoryAPI(id: string) {
  return serviceRequest(() => Service.referralControllerGetHistory(id, true));
}
